//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'collect',
  components: {
  },
  data () {
    return {
      id:0,
      code:'',
      num:1,
      pop:true,
      filePath: [],
      pics:[],
    }
  },
  created(){
   
  },
  mounted(){
    this.id = Number(this.$route.params.id);
    // this.changePop();
    this.sign();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  methods:{
    changePop(){
      this.pop = !this.pop;
    },
    scanQRCode(){
      // this.pop = false;
      let that = this;
      wx.ready(()=> {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode'],
          success: function (res) {
            setTimeout(()=>{
              that.code = that.$func.parseScanResult(res.resultStr);
              // that.pop = true;
            },1000);
          }
        })
      });
      // wx.error((res)=> {
      //   console.log(res)
      //   alert(res.errMsg);
      // })
    },  
    sign(){
      let url = (window.location.href).split('#');
      if(url[0].indexOf('?') != '-1'){
        url = url[0].split('?');
      }
      this.$api.wxSign({url:url[0]}).then((res)=>{
        wx.config({
            debug: res.data.debug, // 开启调试模式,
            // debug: true, // 开启调试模式,
            appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature,// 必填，签名，见附录1
            jsApiList: res.data.jsApiList || ['scanQRCode','chooseImage','uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    submit(){
      if(!this.code){
        return false;
      }
      if (!this.code) {
          this.$func.showToast('请先扫描扎带条码');
          return false;
      }
      if (!this.num) {
          this.$func.showToast('请输入收衣总数量');
          return false;
      }
      this.$api.collect({id:this.id,code:this.code,num:this.num,pics:this.pics}).then((res)=>{
        if(res){
          this.$func.showToast('收衣成功');
          wx.ready(function () {
              let media = document.getElementById("musicBox");
              media.src = "https://fcwash.uunbiot.com/uploads/default/shouyicheggong.mp3"
              media.play();
          });
          setTimeout(()=>{
            this.$router.go(-1);
          },2000)
        }
      })  
    },
    uploadFile(){
        let that = this;
        wx.chooseImage({
                count: 9,
                sizeType: ['original', 'compressed'], 
                sourceType: ['album', 'camera'], 
                success: function (res) {
                    that.uploadImg(res.localIds);
                }
            });
        },
    uploadImg(localIds){
        let localId = localIds.pop();
        let that = this;
        wx.uploadImage({
            localId: localId, 
            success: function (res) {
            that.$api.uploadsImg({serverId:res.serverId,path:'collect'}).then((res)=>{
                if(res){
                that.filePath.push(res.data.url);
                that.pics.push(res.data.path);
                if(localIds.length > 0){
                    that.uploadImg(localIds);
                }
                }
            })
            }
        });
      },
      showPic(index) {
        wx.previewImage({
            current: this.filePath[index], // 当前显示图片的http链接
            urls: this.filePath // 需要预览的图片http链接列表
        });
      },
      delImg(index){
        this.filePath.splice(index,1);
        this.pics.splice(index,1);
      }
  }
}



// WEBPACK FOOTER //
// ./src/pages/collect.vue